<!--
 * @Author: atdow
 * @Date: 2025-08-02 23:18:58
 * @LastEditors: null
 * @LastEditTime: 2026-01-28 19:51:02
 * @Description: file description
-->
<template>
  <el-config-provider :locale="lang">
    <router-view></router-view>
  </el-config-provider>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import iconfontInit from '/@/utils/iconfont'
import { setTitleFromRoute } from '/@/utils/common'
import { useConfig } from '/@/stores/config'
import { Local } from '/@/utils/storage'
import { ADMIN_INFO } from '/@/stores/constant/cacheKey'
import { useAdminInfo } from '/@/stores/adminInfo'
// modules import mark, Please do not remove.

const config = useConfig()
const route = useRoute()
const adminInfo = useAdminInfo()

// 初始化 element 的语言包
const { getLocaleMessage } = useI18n()
const lang = getLocaleMessage(config.lang.defaultLang) as any

const handleVisibilityChange = () => {
  if (document.visibilityState !== 'visible') {
    return
  }

  const getLocalToken = () => {
    try {
      const adminInfoData = Local.get(ADMIN_INFO)
      return adminInfoData?.token || ''
    } catch (error) {
      return ''
    }
  }

  const localToken = getLocalToken()
  if (localToken !== adminInfo.getToken()) {
    window.location.reload()
  }
}

onMounted(() => {
  iconfontInit()
  document.addEventListener('visibilitychange', handleVisibilityChange)
  // Modules onMounted mark, Please do not remove.
})

onUnmounted(() => {
  document.removeEventListener('visibilitychange', handleVisibilityChange)
})

// 监听路由变化时更新浏览器标题
watch(
  () => route.path,
  () => {
    setTitleFromRoute()
  }
)
</script>
